<template>
    <div class="item-preview">
        <ItemPreview
            :content="item.content"
            :image="item.image"
            :btn-title="$t('articles.btnPreviewTitle')"
            :btn-click="handleBtnClick"
            :loading="loading"
            isHtmlContent
        />
    </div>
</template>

<script setup lang="ts">
import { ref } from '@vue/runtime-core';
import router from '@/router';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/user';
import { navigateToWithErrorToast } from '@/hooks/NavigateHooks';
import type { IArticleResponse } from '@/models/ArticleModel';
import ArticleApi from '@/api/v1/ArticleApi';
import ItemPreview from '@/components/molecules/ItemPreview.vue';

const loading = ref<boolean>(false);
const item = ref<IArticleResponse | null>({
    id: null,
    uuid: null,
    created_at: null,
    name: null,
    lead: null,
    image: null,
    content: null,
    product_id: null,
});
const articleApi = new ArticleApi();
const { isAdmin, isPh, isAdminColian } = storeToRefs(useUserStore());
const articlesDetails = async() => {
    loading.value = true;
    try {
        const result = await articleApi.articleDetails(router.currentRoute.value.params.id, isAdmin.value || isAdminColian.value);
        if (!result.isSuccess) {
            navigateToWithErrorToast('/articles-ph', t('articles.toast.errorArticleDetails'))
            loading.value = false;
            return;
        }
        item.value = result.payload;
    } catch (e) {
        navigateToWithErrorToast('/articles-ph', t('articles.toast.errorArticleDetails'))
        loading.value = false;
        return;
    }
    loading.value = false;
};
articlesDetails();

const handleBtnClick = () => {
    if (isPh.value) {
        router.push('/articles-ph');
    } else {
        router.push('/articles');
    }
};
</script>

<style scoped lang="scss">
.item-preview {

}
</style>
